<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">

      <template slot="left" >
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-printer-3d-nozzle</v-icon>{{$t('profile.nozzle.nozzles')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <NozzleForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import NozzleForm from '../../components/nozzle/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'Nozzle';

const { mapFields } = createHelpers({
  getterType: 'nozzle/getField',
  mutationType: 'nozzle/updateField'
});

export default {
  name: 'NozzleCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    NozzleForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('nozzle', ['create', 'reset'])
  }
};
</script>
